import { connect } from 'react-redux';
import { openScheduledCommonRoomPosts } from '@app/actions/navigation/openScheduledPosts';
import { COMMON_ROOM } from '@core/constants/postFeedType';
import {
  accessingCurrentSpaceAsStaff,
  hasFinishedFetchingPostsSelector,
  isInstructor,
  isUpdatingPostIdInSpace,
} from '@core/selectors/classroom';
import { currentUserId } from '@core/selectors/user';
import {
  getNextScheduledPost,
  getScheduledPostsCount,
} from '@core/selectors/space';
import { deleteSpacePost } from '@core/actions/space/posts';
import { canDeletePost } from '../../Shared/PostCard/permissions';
import ScheduledPostsSummaryView from './ScheduledPostsSummary';

export const mapStateToProps = (state) => {
  const scheduledPost = getNextScheduledPost(state, COMMON_ROOM);
  const userId = currentUserId(state);

  return {
    canDeleteScheduledPost: Boolean(
      scheduledPost &&
        canDeletePost({
          isAuthor: scheduledPost.user.objectId === userId,
          isEducator: isInstructor(state, userId),
          isReadOnlyUser: accessingCurrentSpaceAsStaff(state),
        })
    ),
    hasFinishedFetchingPosts: hasFinishedFetchingPostsSelector(state),
    isUpdatingScheduledPost: scheduledPost
      ? isUpdatingPostIdInSpace(state)(scheduledPost.objectId)
      : false,
    scheduledPost,
    scheduledPostCount: getScheduledPostsCount(state, COMMON_ROOM),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onDeleteScheduledPost: (post) => dispatch(deleteSpacePost(post.objectId)),
  onViewScheduledPosts: () => dispatch(openScheduledCommonRoomPosts()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduledPostsSummaryView);
